export const queryPage = '/icps/system/sign/cloudSell/engineeringManagement/QueryPage'
import request from '@/utils/request'
/**获取结算维护*/
export function querySettlement(params) {
  return request({
    url: '/icps/engineering-settlement/query',
    method: "get",
    params,
  })
}
/**保存结算*/
export function saveSettlement(data) {
  return request({
    url: '/icps/engineering-settlement/save_or_update',
    method: 'post',
    data
  })
}
/**保存结算*/
export function updateUrl(data) {
  return request({
    url: '/icps/engineering-settlement/updateUrl',
    method: 'post',
    data
  })
}
/**修改返回时间*/
export function updateReturnTime(data) {
  return request({
    url: '/icps/engineering-settlement/updateReturnTime',
    method: 'post',
    data
  })
}
/**获取工程维护*/
export function queryMaintenance(data) {
  return request({
    url: '/icps/system/sign/cloudSell/control/queryMaintenance',
    method: 'post',
    data
  })
}
/**保存工程维护*/
export function saveMaintenance(data) {
  return request({
    url: '/icps/system/sign/cloudSell/control/saveMaintenance',
    method: 'post',
    data
  })
}
/**修改工程调控*/
export function saveControl(data) {
  return request({
    url: '/icps/system/sign/cloudSell/control/saveControl',
    method: 'post',
    data
  })
}
/**查询工程调控*/
export function queryControl(data) {
  return request({
    // url: '/icps/system/sign/cloudSell/control/queryControl',原接口
    url: '/icps/system/sign/cloudSell/control/queryControlNew',
    method: 'post',
    data
  })
}
/**保存或修改信息调价*/
export function savePhase(data) {
  return request({
    url: '/icps/system/sign/cloudSell/control/savePhase',
    method: 'post',
    data
  })
}
/**获取工程调价*/
export function queryPrising(data) {
  return request({
    url: '/icps/system/sign/cloudSell/control/queryPrising',
    method: 'post',
    data
  })
}
/**保存或修改信息调价*/
export function savePrising(data) {
  return request({
    url: '/icps/system/sign/cloudSell/control/savePrising',
    method: 'post',
    data
  })
}
/**获取合同价格*/
export function getDisClostDisAddCost(data) {
  return request({
    url: '/icps/system/sign/cloudSell/disclose/getDisClostDisAddCost',
    method: 'post',
    data
  })
}
/**修改合同价格*/
export function saveOrUpdateDisAddCost(data) {
  return request({
    url: '/icps/system/sign/cloudSell/disclose/saveOrUpdateDisAddCost',
    method: 'post',
    data
  })
}
/**查询调价*/
export function getRevisePriceProduction(data) {
  return request({
    url: '/icps/system/sign/cloudSell/disclose/getRevisePriceProduction',
    method: 'post',
    data
  })
}
/**添加调价*/
export function updateRevisePrice(data) {
  return request({
    url: '/icps/system/sign/cloudSell/disclose/updateRevisePrice',
    method: 'post',
    data
  })
}
/**删除调价*/
export function deleteRevisePrice(data) {
  return request({
    url: '/icps/system/sign/cloudSell/disclose/deleteRevisePrice',
    method: 'post',
    data
  })
}
// 获取调价记录
export function getRevisePrice(params) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/getRevisePrice",
    method: "post",
    data: params,
  });
}
// 删除信息价强度等级
export function updatePrising(params) {
  return request({
    url: "/icps/system/sign/cloudSell/control/updatePrising",
    method: "get",
    params,
  });
}

// 设置产品价格
export function saveReadjustPricesResord(params) {
  return request({
    url: "/icps/system/sign/cloudSell/productCost/saveReadjustPricesResord",
    method: "post",
    data: params,
  });
}

// 获取生效记录
export function queryResordPage(params) {
  return request({
    url: "/icps/system/sign/cloudSell/productCost/queryResordPage",
    method: "post",
    data: params,
  });
}

// 删除生效记录
export function delReadjustPricesResord(params) {
  return request({
    url: "/icps/system/sign/cloudSell/productCost/delReadjustPricesResord",
    method:"get",
    params
  });
}

// 获取交底信息
export function queryDisclose(params) {
  return request({
    url: "/icps/system/sign/cloudSell/productCost/queryDisclose",
    method:"get",
    params
  });
}

// 获取交底信息
export function queryReadjustCostDetail(params) {
  return request({
    url: "/icps/system/sign/cloudSell/productCost/queryReadjustCostDetail",
    method: "post",
    data: params,
  });
}


// 信息调价-获取界面数据
export function queryInfoReadjustCostDetail(params) {
  return request({
    url: "/icps/system/sign/cloudSell/productCost/queryReadjustCostDetail",
    method: "post",
    data: params,
  });
}



// 获取调价记录
export function queryGradeAjustResord(params) {
  return request({
    url: "/icps/system/sign/cloudSell/productCost/queryGradeAjustResord",
    method:"get",
    params
  });
}

// 信息调价-保存
export function saveOrUpdateInfoConsultPrice(params) {
  return request({
    url: "/icps/system/sign/cloudSell/productCost/saveOrUpdateConsultPrice",
    method: "post",
    data: params,
  });
}


// 保存产品调价
export function saveOrUpdateConsultPrice(data) {
  return request({
    url: "/icps/system/sign/cloudSell/productCost/saveOrUpdateConsultPrice",
    method:"post",
    data
  });
}
// 产品调价-调价规则基准价获取期数
export function queryPeriodsByCity(params) {
  return request({
    url: "/icps/system/sign/basics/information/price/queryPeriodsByCity",
    method:"get",
    params
  });
}
// 产品调价-调价规则基准价获取标号和区域
export function queryAreaByPeriods(params) {
  return request({
    url: "/icps/system/sign/basics/information/price/queryAreaByPeriods",
    method:"get",
    params
  });
}
// 产品调价-调价规则信息价获取标号
export function queryGradeList(data) {
  return request({
    url: "/icps/system/sign/basics/namingRule/queryGradeList",
    method:"post",
    data
  });
}
export function queryPatternList(data) {
  return request({
    url: "/icps/system/sign/basics/information/price/queryPatternList",
    method:"post",
    data
  });
}

// 保存特殊条款
export function updateMixRatio(data) {
  return request({
    url: "/icps/system/sign/cloudSell/engineeringManagement/updateMixRatio",
    method:"post",
    data
  });
}


// 保存产品调价设置
export function saveOrUpdatePriceRule(data) {
  return request({
    url: "/icps/system/sign/cloudSell/productCost/saveOrUpdatePriceRule",
    method:"post",
    data
  });
}


// 保存小方量运输费用
export function saveSmallVolumeTransportation(data) {
  return request({
    url: "/icps/system/sign/cloudSell/pumpingCosts/saveSmallVolumeTransportation",
    method:"post",
    data
  });
}

// 获取小方量运输费用
export function querySmallVolumeTransportation(data) {
  return request({
    url: "/icps/system/sign/cloudSell/pumpingCosts/querySmallVolumeTransportation",
    method:"post",
    data
  });
}


//获取产品调价设置
export function queryPriceRule(params) {
  return request({
    url: "/icps/system/sign/cloudSell/productCost/queryPriceRule",
    method:"get",
    params
  });
}
//获取泵机类型
export function queryPumpList(params) {
  return request({
    url: "/icps/system/sign/cloudSell/pumpingCosts/queryPumpList",
    method:"get",
    params
  });
}
//获取泵送费用数据
export function queryPumpCost(params) {
  return request({
    url: "/icps/system/sign/cloudSell/pumpingCosts/queryPumpCost",
    method:"get",
    params
  });
}
//保存泵送费用数据
export function savePumpCost(data) {
  return request({
    url: "/icps/system/sign/cloudSell/pumpingCosts/savePumpCost",
    method:"post",
    data
  });
}
//保存泵送费调价
export function savePsavePumpCostAdjustumpCost(data) {
  return request({
    url: "/icps/system/sign/cloudSell/pumpingCosts/savePumpCostAdjust",
    method:"post",
    data
  });
}
//删除泵送费调价
export function delPumpCostAdjust(params) {
  return request({
    url: "/icps/system/sign/cloudSell/pumpingCosts/delPumpCostAdjust",
    method:"get",
    params
  });
}
//获取泵送费调价记录 
export function queryPumpCostAdjust(params) {
  return request({
    url: "/icps/system/sign/cloudSell/pumpingCosts/queryPumpCostAdjust",
    method:"get",
    params
  });
}
//获取价格复用列表
export function queryResordlist(data) {
  return request({
    url: "/icps/system/sign/cloudSell/productCost/queryResordlist",
    method:"post",
    data
  });
}
//获取价格复用列表
export function queryResordEngineeringList(params) {
  return request({
    url: "/icps/system/sign/cloudSell/productCost/queryResordEngineeringList",
    method:"get",
    params
  });
}
//工程结算获取
export function queryEngineeringSettle(data) {
  return request({
    url: "/icps/system/sign/settlement/engCycle/queryEngineeringSettle",
    method:"post",
    data
  });
}
//工程结算修改
export function updateSettle(data) {
  return request({
    url: "/icps/system/sign/settlement/engCycle/updateSettle",
    method:"post",
    data
  });
}
//工程调价 审批修改状态
export function updateStatus(data) {
  return request({
    url: "/icps/system/sign/cloudSell/productCost/updateStatus",
    method:"post",
    data
  });
}

